import ViewFantacyMatchs from './ViewFantacyMatchs';

export default ViewFantacyMatchs;